/* eslint-disable class-methods-use-this */
import CardRowHtml from './rfct/html/card-row-html';
import CardSliderHtml from './rfct/html/card-slider-html';
import MediaCardHtml from './rfct/html/media-card-html';
import ProductCardSmallHtml from './rfct/html/product-card-small-html';
import ProductCartButtonHtml from './rfct/html/product-cart-button-html';
import ProductCategoriesHtml from './rfct/html/product-categories-html';
import moduleRegistry from './rfct/module-registry/module-registry';

// foreach helper for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

/* eslint-disable no-unused-expressions */
// eslint-disable-next-line no-undef
let $globalConfig;
if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    $globalConfig = config;
}
// const $etCommerce = etCommerce;
let $etCommerce = null;

const productConfig = {
    selectors: {
        catalogDetail: '#catalog',
        product: '.product',
        consistOfProducts: '.consist_of_products',
        productDetails: '.product-details',
        galleryLightbox: '.gallery-lightbox',
        cartInput: '.rfct-input__input',
        cartInputPlusMinus: '.rfct-input-plus-minus',
        documentsTab: '#product-documents-tab',
        cartButton: '.action-card__shop-button',
        addToCartForm: '#product-quantity',
        ammountInput: '#action-card__amount',
        cardSlider: '.rfct-card-slider__slide',
    },
};

export default class CatalogDetail {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
    }

    init() {
      //add aria label for ammount
        if($(productConfig.selectors.ammountInput)) {
            $(productConfig.selectors.ammountInput).attr('aria-label', $globalConfig.textResources.productCatalogConnectorConfig.amount)
        }
        this._$params = new URLSearchParams(window.location.search);
        // eslint-disable-next-line no-unused-vars
        this._$productID = !isNaN(this._$params.get('productID')) ? this._$params.get('productID') : '';
        this._$category = !isNaN(this._$params.get('cat')) ? this._$params.get('cat') : '';
        // eslint-disable-next-line no-undef
        this._myLazyLoad = new LazyLoad();

        // Execute a function when the user releases a key on the keyboard
        const form = jQuery(productConfig.selectors.addToCartForm)[0] || false;

        if (form) {
            // eslint-disable-next-line func-names
            form.onsubmit = function (event) {
                event.preventDefault();
                jQuery(productConfig.selectors.cartButton)[0].click();
            };
        }

        if ($(productConfig.selectors.product).length > 0) {
            const product = $(productConfig.selectors.product)[0];
            const productIdentifier = product.getAttribute('data-id');

            // eslint-disable-next-line no-empty
            if (typeof etCommerce === 'undefined') {

            } else {
                // eslint-disable-next-line no-undef
                $etCommerce = etCommerce;
            }

            // eslint-disable-next-line max-len
            if (productIdentifier && $etCommerce) {
                const etrackerCategory = [];

                // eslint-disable-next-line no-undef
                if (etrackerCategoryForOrder.length) {
                    // eslint-disable-next-line no-undef
                    etrackerCategoryForOrder.forEach((etrackerCategoryItem) => {
                        etrackerCategory.push(etrackerCategoryItem);
                    });
                    etrackerCategory.push('Products');
                } else {
                    etrackerCategory.push('Products');
                }

                const etCommerceProduct = {
                    id: this._$productID,
                    name: productIdentifier,
                    category: etrackerCategory,
                    price: '1.00',
                    currency: 'EUR',
                    variants: {},
                };

                // eslint-disable-next-line no-undef
                $etCommerce.sendEvent('viewProduct', etCommerceProduct);
            }

            this._myLazyLoad.update();
            // eslint-disable-next-line no-undef
            this._pictureFill();
            // TODO: initializeLightboxes();
            this._initLightbox(jQuery(productConfig.selectors.galleryLightbox));
            this._initConsistOfProducts();
            this._loadCategories();
            this._initProductDocumentsTab();
            this._initProduct();
            this._initButtons();
            // initAddToCart();
            setTimeout(() => {
                jQuery('.loading').removeClass('loading').addClass('loaded');
            }, 1000);
        }
    }

    _initProductDocumentsTab() {
        // eslint-disable-next-line no-unused-vars
        jQuery(productConfig.selectors.documentsTab).on('click', (e) => {
            if (!(jQuery('#documents').hasClass('loaded'))) {
                jQuery('#documents').addClass('loaded');
                this._loadDocuments(jQuery('#documents'));
            }
        });
    }

    // init logic
    _initLightbox($lightBoxes) {
        $lightBoxes.imageLightbox({
            button: true,
            overlay: true,
            animationSpeed: 250,
            arrows: true,
            navigation: true,
            caption: true,
            gutter: 10,
            history: false,
        });

        // initializeLightboxes();
    }

    _checkVisible(elm) {
        const rect = elm.getBoundingClientRect();
        const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    }


    _initConsistOfProducts() {
        $(productConfig.selectors.consistOfProducts).each((i, el) => {
            const $consistOfProducts = $(el);
            this._getConsistsOfProducts($consistOfProducts);
        });
    }

    _initProduct() {
        $(productConfig.selectors.product).each((i, el) => {
            const $product = $(el);
            this._initProductDetail($product);
        });
    }

    _initProductDetail() {
        jQuery(window).scroll(() => {
            this._loadData();
            setTimeout(() => {
                jQuery('.loading').removeClass('loading').addClass('loaded');
            }, 1000);
        });
    }

    // eslint-disable-next-line no-unused-vars
    _loadData($product) {
        $(productConfig.selectors.productDetails).each((i, el) => {
            const $productDetail = $(el);
            if (this._checkVisible(el) && !($productDetail.hasClass('loaded'))) {
                $productDetail.addClass('loaded');
                const id = $productDetail.attr('id');
                switch (id) {
                    case 'product-details':
                        break;
                    case 'accessories':
                        this._loadAccessories(jQuery('#required-accessories'), true);
                        this._loadAccessories(jQuery('#optional-accessories'), false);
                        break;
                    case 'similar-products':
                        this._loadSimilarProducts(jQuery('#similar-products'));
                        break;
                    case 'documents':
                        this._loadDocuments(jQuery('#documents'));
                        break;
                    case 'processing-products':
                        this._loadProcessingProducts(jQuery('#processing-products'));
                        break;
                    case 'spare-parts':
                        this._loadSpareParts(jQuery('#spare-parts'));
                        break;
                    default:
                        // eslint-disable-next-line no-console
                        // console.log('Not known id...');
                }
            }
        });
    }

    _loadCategoriesData(categories) {
        // console.log('categories', categories);
        if (categories.categories.length > 0) {
            // eslint-disable-next-line max-len
            const categoriesContent = new ProductCategoriesHtml($globalConfig.textResources.productCatalogConnectorConfig.additionalProductGroupsHeadline, categories.categories, true).toString();
            jQuery('#product-categories').append(categoriesContent);
        } else {
            // eslint-disable-next-line newline-per-chained-call
            jQuery('#product-categories').hide();
        }

        if (categories.procedures.length > 0) {
            // eslint-disable-next-line max-len
            const categoriesContent = new ProductCategoriesHtml($globalConfig.textResources.productCatalogConnectorConfig.additionalProceduresHeadline, categories.procedures, false).toString();
            jQuery('#product-indications').append(categoriesContent);
        } else {
            // eslint-disable-next-line newline-per-chained-call
            jQuery('#product-indications').hide();
        }

        if (!(categories.categories.length > 0) && !(categories.procedures.length > 0)) {
            jQuery('#product-additional-categories-tab').hide();
            jQuery('#product-additional-categories-data').hide();
        }
    }

    _loadAccessories(id, required) {
        const _this = this;
        const stringSectionTitle = '';
        // eslint-disable-next-line max-len
        const stringSliderTitle = required ? $globalConfig.textResources.productCatalogConnectorConfig.labelAccessoriesSubtitle1 : $globalConfig.textResources.productCatalogConnectorConfig.labelAccessoriesSubtitle2;
        const $params = new URLSearchParams(window.location.search);
        const $category = $params.get('cat') || '';
        const accesoriesType = required ? 'Required Accessories' : 'Optional accessories';
        let apiURL;

        if ($category) {
            apiURL = `${$globalConfig.urls.getAccessoriesJson + this._$productID}/accessories?procedure=${$category}`;
            apiURL += required ? `&required=${required}` : '';
        } else {
            apiURL = `${$globalConfig.urls.getAccessoriesJson + this._$productID}/accessories`;
            apiURL += required ? `?required=${required}` : '';
        }

        jQuery.ajax({
            type: 'GET',
            url: apiURL,
            processData: false,
            dataType: 'json',
            success(data) {
                if (data.products.length > 0) {
                    const additionalProductsContainer = id;
                    const productCardsHtml = _this._generateCards(data.products, accesoriesType);
                    // eslint-disable-next-line max-len
                    const cardSliderHtml = new CardSliderHtml(stringSliderTitle, stringSectionTitle, productCardsHtml, 4).toString();
                    moduleRegistry.insertHTML(additionalProductsContainer.children('.product-details__content'), cardSliderHtml);
                    // this._myLazyLoad.update();
                    // eslint-disable-next-line no-undef
                    _this._pictureFill();
                    _this._initButtons();
                    _this._myLazyLoad.update();
                    $('[data-toggle="tooltip"]').tooltip();

                    id.parent().attr('data-hidden', 'false');
                    id.parent().attr('data-updated', 'true');
                    id.parent().show();
                    additionalProductsContainer.children('.product-details__skeleton').hide();
                    additionalProductsContainer.children('.product-details__content').show();
                    additionalProductsContainer.find(productConfig.selectors.cardSlider).attr('tabindex','-1')
                } else {
                    id.hide();
                }

            },
            error(data) {
                id.hide();
                // eslint-disable-next-line no-console
                // console.log(`Error loading accesories: ${id.attr('id')}${data}`);
            },
        });
    }

   async _loadDocuments(id) {
        const url = `${$globalConfig.urls.getProductFilmsAndDocuments}?productID=${this._$productID}`;
        const data = await jQuery.get(url);

        const documentsContainer = id;
        const documentMediaCardsHtml = [];
        const country = documentsContainer[0].getAttribute('data-country').toUpperCase() || '';
        const eifuURL = documentsContainer[0].getAttribute('data-url') || '';
        const articleID = documentsContainer[0].getAttribute('data-article') || '';
        const linkLabel = documentsContainer[0].getAttribute('data-Label') || '';

        const eifuBlock = `<h3 class="rfct-card-slider__subline">${$globalConfig.textResources.productCatalogConnectorConfig.labelTechnicalDocuments}</h3>
        <div class="rfct-card-media-container">
            <div class="rfct-card-media-item col-xs-12 col-sm-6 col-md-4">
                <div class="rfct-product-card-small__buttons" style="position: relative; bottom: 0;">
                    <a target="_blank" href="${eifuURL + country}/ART?item=${articleID}" class="cta-button cta-button--primary" style="margin: 0; padding-right: 0; padding-left: 0;">                 
                        <span class="cta-button__icon cta-button__icon--left" style="padding-right: 0;" >
                            <svg style="width: 24px;height: 24px;fill: transparent;" viewBox="0 0 24 24"><g><path d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>
                        </span>
                        ${linkLabel}
                    </a>
                </div>
            </div>
        </div>`;

        console.log('eifuBlock', eifuBlock);

        if (data.category && data.category.numFound && data.category.numFound > 0) {
            data.category.documentReferences.forEach((document) => {
                if (document.type !== 'video') {
                    // eslint-disable-next-line max-len
                    const documentURL = $globalConfig.urls.mediaFilesURL + document.sourceMediaIdentifier;
                    const mediaCardHtml = new MediaCardHtml(document, documentURL).toString();
                    documentMediaCardsHtml.push(mediaCardHtml);
                } else {
                    const documentURL = $globalConfig.urls.videoFilesURL + document.materialNumber;
                    const mediaCardHtml = new MediaCardHtml(document, documentURL).toString();
                    documentMediaCardsHtml.push(mediaCardHtml);
                }
            });
        }

        const documentCardSliderHtml = (documentMediaCardsHtml.length > 0) ? new CardRowHtml('', $globalConfig.textResources.productCatalogConnectorConfig.labelBrochuresAndFilms, documentMediaCardsHtml, 3).toString() : '';
        moduleRegistry.insertHTML(documentsContainer.children('.product-details__content'), documentCardSliderHtml + eifuBlock);

        this._myLazyLoad.update();
        // eslint-disable-next-line no-undef
        this._pictureFill();
        this._initButtons();
        $('[data-toggle="tooltip"]').tooltip();
        documentsContainer.children('.product-details__skeleton').hide();
        documentsContainer.children('.product-details__content').show();
        $('.popup-iframe').magnificPopup({ type: 'iframe' });

    }

    async _loadSpareParts(id) {
        const url = `${$globalConfig.urls.getSpareParts}?productID=${this._$productID}`;
        const data = await jQuery.get(url);

        const stringSectionTitle = id.attr('data-title');

        if (data.products.length > 0) {
            const additionalProductsContainer = id;
            const productCardsHtml = this._generateCards(data.products, 'Spare parts');
            const cardSliderHtml = new CardSliderHtml(stringSectionTitle || '', '', productCardsHtml, 4).toString();
            moduleRegistry.insertHTML(additionalProductsContainer.children('.product-details__content'), cardSliderHtml);
            this._myLazyLoad.update();
            // eslint-disable-next-line no-undef
            this._pictureFill();
            this._initButtons();
            $('[data-toggle="tooltip"]').tooltip();
            additionalProductsContainer.children('.product-details__skeleton').hide();
            additionalProductsContainer.children('.product-details__content').show();
            additionalProductsContainer.find(productConfig.selectors.cardSlider).attr('tabindex','-1')
        } else {
            id.hide();
            // id.find('h2').hide();
        }
    }

    async _loadProcessingProducts(id) {
        const url = `${$globalConfig.urls.getProductProcessingAccessories}?productID=${this._$productID}`;
        const data = await jQuery.get(url);

        const stringSectionTitle = id.attr('data-title');

        if (data.products.length > 0) {
            const additionalProductsContainer = id;
            const productCardsHtml = this._generateCards(data.products, 'Processing parts');
            const cardSliderHtml = new CardSliderHtml(stringSectionTitle || '', '', productCardsHtml, 4).toString();
            moduleRegistry.insertHTML(additionalProductsContainer.children('.product-details__content'), cardSliderHtml);
            this._myLazyLoad.update();
            // eslint-disable-next-line no-undef
            this._pictureFill();
            this._initButtons();
            $('[data-toggle="tooltip"]').tooltip();
            additionalProductsContainer.children('.product-details__skeleton').hide();
            additionalProductsContainer.children('.product-details__content').show();
            additionalProductsContainer.find(productConfig.selectors.cardSlider).attr('tabindex','-1')
        } else {
            id.hide();
            // id.find('h2').hide();
        }
    }

    async _loadSimilarProducts(id) {
        const url = `${$globalConfig.urls.getRelatedProducts}?productID=${this._$productID}`;
        const data = await jQuery.get(url);
        const stringSectionTitle = id.attr('data-title');

        if (data.products.length > 0) {
            const additionalProductsContainer = id;
            const productCardsHtml = this._generateCards(data.products, 'Related products');
            const cardSliderHtml = new CardSliderHtml(stringSectionTitle || '', '', productCardsHtml, 4).toString();
            moduleRegistry.insertHTML(additionalProductsContainer.children('.product-details__content'), cardSliderHtml);
            this._myLazyLoad.update();
            // eslint-disable-next-line no-undef
            this._pictureFill();
            this._initButtons();
            $('[data-toggle="tooltip"]').tooltip();
            additionalProductsContainer.children('.product-details__skeleton').hide();
            additionalProductsContainer.children('.product-details__content').show();
            additionalProductsContainer.find(productConfig.selectors.cardSlider).attr('tabindex','-1')
        } else {
            id.hide();
            // id.find('h2').hide();
        }
    }

    async _getConsistsOfProducts(id) {
        const url = `${$globalConfig.urls.getConsistsOf}?productID=${this._$productID}`;
        const data = await jQuery.get(url);

        if (data.numFound) {
            let consistOfProducts = '';
            data.products.forEach((product) => {
                consistOfProducts += `<tr class="rfct-shipment-table__tr">
                    <td class="rfct-shipment-table__td">
                        <a class="rfct-link" href="?cat=${this._$category}&productID=${product.identifier}">${product.productId}</a>
                    </td>
                    <td class="rfct-shipment-table__td">
                        <a class="rfct-link" href="?cat=${this._$category}&productID=${product.identifier}">${product.name ? product.name : ''} (${product.numberOfPartsInDelivery || 0})</a>
                    </td>
                </tr>`;
            });
            id.append(consistOfProducts);
        } else {
            id.parent().hide();
        }
    }

    async _loadCategories() {
        const url = `${$globalConfig.urls.getProductCategories}?productID=${this._$productID}`;
        const data = await jQuery.get(url);

        const categories = {
            categories: [],
            procedures: [],
        };

        const productCategoryTaxonomies = data.productCategoryTaxonomies.filter((tax) => tax.idPath.startsWith('0'));
        const indicationTaxonomies = data.indicationTaxonomies.filter((tax) => tax.idPath.startsWith('1'));

        if (productCategoryTaxonomies.length > 0) {
            productCategoryTaxonomies.forEach((category) => {
                const arrayProductCategoryNames = category.namePath.split('#');
                const arrayProductCategoryIDs = category.idPath.split('#');
                if (arrayProductCategoryNames.length > 3) {
                    const mainCategoryName = arrayProductCategoryNames[1];
                    const mainCategoryID = arrayProductCategoryIDs[1];

                    const mainCategory = {
                        main: mainCategoryName,
                        identifier: mainCategoryID,
                        categories: [],
                    };
                    const childCategory = {
                        name: '',
                        identifier: '',
                    };

                    arrayProductCategoryNames.forEach((singleName, Nameindex) => {
                        if (Nameindex > 2) {
                            childCategory.name += Nameindex > 3 ? `#${singleName}` : singleName;
                        }
                    });

                    arrayProductCategoryIDs.forEach((singleID, IdIndex) => {
                        if (IdIndex > 2) {
                            childCategory.identifier += IdIndex > 3 ? `#${singleID}` : singleID;
                        }
                    });

                    let mainCategoryExist = false;

                    categories.categories.forEach((categoryMain) => {
                        if (categoryMain.identifier === mainCategoryID) {
                            mainCategoryExist = true;
                            categoryMain.categories.push(childCategory);
                        }
                    });

                    if (!mainCategoryExist) {
                        mainCategory.categories.push(childCategory);
                        categories.categories.push(mainCategory);
                    }
                }
            });
        } else {
            // eslint-disable-next-line newline-per-chained-call
            // jQuery('#product-categories').parent().parent().parent().hide();
        }

        if (indicationTaxonomies.length > 0) {
            indicationTaxonomies.forEach((procedure) => {
                const arrayProductCategoryNames = procedure.namePath.split('#');
                const arrayProductCategoryIDs = procedure.idPath.split('#');
                if (arrayProductCategoryNames.length > 3) {
                    const mainCategoryName = arrayProductCategoryNames[1];
                    const mainCategoryID = arrayProductCategoryIDs[1];

                    const mainCategory = {
                        main: mainCategoryName,
                        identifier: mainCategoryID,
                        categories: [],
                    };
                    const childCategory = {
                        name: '',
                        identifier: '',
                    };

                    arrayProductCategoryNames.forEach((singleName, Nameindex) => {
                        if (Nameindex > 2) {
                            childCategory.name += Nameindex > 3 ? `#${singleName}` : singleName;
                        }
                    });

                    arrayProductCategoryIDs.forEach((singleID, IdIndex) => {
                        if (IdIndex > 2) {
                            childCategory.identifier += IdIndex > 3 ? `#${singleID}` : singleID;
                        }
                    });

                    let mainCategoryExist = false;

                    categories.procedures.forEach((categoryMain) => {
                        if (categoryMain.identifier === mainCategoryID) {
                            mainCategoryExist = true;
                            categoryMain.categories.push(childCategory);
                        }
                    });

                    if (!mainCategoryExist) {
                        mainCategory.categories.push(childCategory);
                        categories.procedures.push(mainCategory);
                    }
                }
            });
        } else {
            // eslint-disable-next-line newline-per-chained-call
            // jQuery('#product-indications').parent().parent().parent().hide();
        }

        this._loadCategoriesData(categories);
    }

    _generateCards(products, productType) {
        const productCardsHtml = [];

        products.forEach((product) => {
            const singleProductCategoryArray = product.categories.length ? product.categories[0].category : '';
            const singleProductMainCategory = singleProductCategoryArray !== '' ? singleProductCategoryArray.split('#') : '';
            const singleProductCategory = singleProductMainCategory[singleProductMainCategory.length - 1] || '';
            const urlcategoryparam = singleProductCategory !== '' ? `&cat=${singleProductCategory}` : '';
            const productUrl = `?productID=${product.identifier}${urlcategoryparam}`;
            // eslint-disable-next-line max-len
            const productCartButton = new ProductCartButtonHtml(product.identifier, product.productId, product.name, productType, '', product.image).toString();
            // eslint-disable-next-line max-len
            const productCard = new ProductCardSmallHtml(productUrl, product.productId, product.name, product.properties, product.image, productCartButton).toString();
            productCardsHtml.push(productCard);
        });
        return productCardsHtml;
    }

    _initButtons() {
        const buttons = document.querySelectorAll('.mdc-button');
        // eslint-disable-next-line no-undef
        buttons.forEach((button) => mdc.ripple.MDCRipple.attachTo(button));
        const fabs = document.querySelectorAll('.mdc-fab');
        // eslint-disable-next-line no-undef
        fabs.forEach((fab) => mdc.ripple.MDCRipple.attachTo(fab));
        const sliders = document.querySelectorAll('.mdc-slider');
        // eslint-disable-next-line no-undef
        sliders.forEach((slider) => mdc.slider.MDCSlider.attachTo(slider));
        const dropDowns = document.querySelectorAll('.mdc-select');
        // eslint-disable-next-line no-undef
        dropDowns.forEach((dropDown) => mdc.select.MDCSelect.attachTo(dropDown));
    }

    _pictureFill() {
        // eslint-disable-next-line no-undef
        picturefill();
    }
}

moduleRegistry.registerModule('CatalogDetail', CatalogDetail);
moduleRegistry.autoApplyModule('CatalogDetail', productConfig.selectors.catalogDetail);
